import { useEffect } from 'react'

const DEFAULT_CONTXT_TITLE = 'Contxt'

type LinkOverrideConfig = {
    selector: string
    href: string
    rel: string
    type?: string
    sizes?: string
}

type LinkOverrideSnapshot = {
    element: HTMLLinkElement
    previousHref: string | null
    created: boolean
}

const SPEAK_TO_KIT_LINK_OVERRIDES: LinkOverrideConfig[] = [
    {
        selector: 'link[rel="icon"][type="image/x-icon"]',
        href: '/stk-favicon.ico',
        rel: 'icon',
        type: 'image/x-icon',
    },
    {
        selector: 'link[rel="icon"][type="image/png"][sizes="16x16"]',
        href: '/stk-favicon-16x16.png',
        rel: 'icon',
        type: 'image/png',
        sizes: '16x16',
    },
    {
        selector: 'link[rel="icon"][type="image/png"][sizes="32x32"]',
        href: '/stk-favicon-32x32.png',
        rel: 'icon',
        type: 'image/png',
        sizes: '32x32',
    },
    {
        selector: 'link[rel="icon"][type="image/png"][sizes="192x192"]',
        href: '/stk-android-chrome-192x192.png',
        rel: 'icon',
        type: 'image/png',
        sizes: '192x192',
    },
    {
        selector: 'link[rel="icon"][type="image/png"][sizes="512x512"]',
        href: '/stk-android-chrome-512x512.png',
        rel: 'icon',
        type: 'image/png',
        sizes: '512x512',
    },
    {
        selector: 'link[rel="apple-touch-icon"]',
        href: '/stk-apple-touch-icon.png',
        rel: 'apple-touch-icon',
    },
    {
        selector: 'link[rel="manifest"]',
        href: '/stk-site.webmanifest',
        rel: 'manifest',
    },
]

export default function useSpeakToKitPageTitle(pageLabel?: string): void {
    useEffect(() => {
        const previousTitle = document.title
        const normalizedPageLabel = pageLabel?.trim()
        const linkSnapshots: LinkOverrideSnapshot[] = []

        for (const override of SPEAK_TO_KIT_LINK_OVERRIDES) {
            let element = document.querySelector<HTMLLinkElement>(
                override.selector,
            )
            let created = false

            if (!element) {
                element = document.createElement('link')
                element.rel = override.rel
                if (override.type) {
                    element.type = override.type
                }
                if (override.sizes) {
                    element.setAttribute('sizes', override.sizes)
                }
                document.head.appendChild(element)
                created = true
            }

            const previousHref = element.getAttribute('href')
            element.setAttribute('href', override.href)
            linkSnapshots.push({
                element,
                previousHref,
                created,
            })
        }

        document.title = normalizedPageLabel
            ? `${normalizedPageLabel} | Speak To Kit`
            : 'Speak To Kit'

        return () => {
            document.title = previousTitle || DEFAULT_CONTXT_TITLE
            for (const snapshot of linkSnapshots.reverse()) {
                if (snapshot.created) {
                    snapshot.element.remove()
                    continue
                }

                if (snapshot.previousHref === null) {
                    snapshot.element.removeAttribute('href')
                    continue
                }

                snapshot.element.setAttribute('href', snapshot.previousHref)
            }
        }
    }, [pageLabel])
}
